module.exports = __webpack_public_path__ + "img/turbo_on.778f2336.svg";